import { render } from "./shift-settings.vue?vue&type=template&id=d5e8fdc4&scoped=true"
import script from "./shift-settings.vue?vue&type=script&lang=js"
export * from "./shift-settings.vue?vue&type=script&lang=js"

import "./shift-settings.vue?vue&type=style&index=0&id=d5e8fdc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5e8fdc4"]])

export default __exports__